import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import styles from '../styles/Navbar.module.css';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className={styles.navbarMinimal}>
      <div className={styles.container}>
        <Link to="/" className={styles.logoMinimal}>
          <img
            src="/assets/images/logo-icon.png"
            alt="Britosa"
            title="Britosa Mudanzas"
            style={{ height: '60px', width: 'auto' }}
          />
          <span style={{ fontSize: '1.2rem', fontWeight: 800, color: 'white', marginLeft: '0.5rem' }}>
            Britosa
          </span>
        </Link>

        <button type="button" aria-label={open ? "Cerrar menú" : "Abrir menú"} aria-expanded={open} aria-controls="main-menu" className={styles.hamburger} onClick={() => setOpen(!open)}>
          {open ? <FaTimes /> : <FaBars />}
        </button>

        <ul id="main-menu" className={`${styles.menuMinimal} ${open ? styles.open : ''}`}>
          <li><Link to="/" onClick={() => setOpen(false)}>Inicio</Link></li>
          <li><Link to="/servicios" onClick={() => setOpen(false)}>Servicios</Link></li>
          <li><Link to="/nosotros" onClick={() => setOpen(false)}>Nosotros</Link></li>
          <li><a href="/blog/">Blog</a></li>
          <li><Link to="/contacto" onClick={() => setOpen(false)}>Contacto</Link></li>
          <li>
            <Link to="/presupuesto" className={styles.ctaBtnMinimal} onClick={() => setOpen(false)}>
              Presupuesto
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
